import { Iconfont } from '@umu/umu-design';
import { PreImg } from 'common/src/components';
import React, { HTMLAttributes } from 'react';
import { IMAGE_TYPE } from '../../interface';

interface IElementIconProps extends HTMLAttributes<any> {
    iconName: string;
    color: string;
    iconType: IMAGE_TYPE;
    imgSrc?: string;
}

const ElementIcon = (props: IElementIconProps) => {
    const { iconName, color = '', iconType, imgSrc = '', className = '', ...rest } = props;
    const isIconFont = iconType === IMAGE_TYPE.SVG;
    return isIconFont ? (
        <Iconfont className={`${className}-font`} {...rest} type={iconName} style={{ color }}></Iconfont>
    ) : imgSrc ? (
        <PreImg>
            <img src={imgSrc} className={className} {...rest}></img>
        </PreImg>
    ) : (
        <div className={className}></div>
    );
};

export { ElementIcon, IElementIconProps };
